var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{ref:"modal"},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"list"},_vm._l((_vm.list),function(user){return _c('div',{key:user.id,staticClass:"row"},[_c('MiniEntity',{attrs:{"entity":user,"link":user.link}}),_c('FollowButton',{attrs:{"id":user.id,"is-following":user.isFollowing}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }